// scroll reveal
const io = new IntersectionObserver((entries)=>{
  entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('is-visible'); } });
},{threshold:.15});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

// add to cart — real Shopify AJAX cart, with graceful fallback
const DEFAULT_VARIANT_ID = 58660266246489; // Blanc (variante B)
const PRODUCT_URL = 'https://wuvqmz-1j.myshopify.com/products/usb-rechargeable-handheld-fabric-steam-iron-3-heat-levels-110-w-mini-handheld-steamer-steamer-for-travel-college-dorm-essentials';

async function addToCart(btn){
  if(btn.classList.contains('is-loading')) return;
  btn.classList.add('is-loading');

  // on the product page, use the variant/quantity actually selected there
  let variantId = DEFAULT_VARIANT_ID;
  let quantity = 1;
  const pdpVariantInput = document.getElementById('pdp-variant-id');
  if(pdpVariantInput){
    variantId = parseInt(pdpVariantInput.value, 10) || DEFAULT_VARIANT_ID;
    const pdpForm = document.getElementById('pdp-form');
    const qtyInput = pdpForm ? pdpForm.querySelector('input[name="quantity"]') : null;
    if(qtyInput) quantity = parseInt(qtyInput.value, 10) || 1;
  }

  try{
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    });
    if(!res.ok) throw new Error('cart add failed');
    btn.classList.remove('is-loading');
    btn.classList.add('is-added');
    // send the customer straight to the real cart so they can check out
    setTimeout(()=>{ window.location.href = '/cart'; }, 500);
  }catch(err){
    // not running on the shop's domain (e.g. local preview) — send them to the real product page instead
    window.location.href = PRODUCT_URL;
  }
}
document.querySelectorAll('.add-to-cart-btn').forEach(btn=>{
  btn.addEventListener('click', (e)=>{
    e.preventDefault(); // avoid a native form submit racing the AJAX call on the product page
    addToCart(btn);
  });
});

// color variant toggles (hero + specs)
document.querySelectorAll('.color-toggle').forEach(toggle=>{
  const key = toggle.dataset.toggleFor;
  const stage = document.querySelector('.product-stage[data-stage="'+key+'"]');
  if(!stage) return;
  toggle.querySelectorAll('.color-toggle-btn').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      const color = btn.dataset.color;
      toggle.querySelectorAll('.color-toggle-btn').forEach(b=>b.classList.toggle('active', b===btn));
      stage.querySelectorAll('.color-img').forEach(img=>{
        img.classList.toggle('active', img.dataset.color === color);
      });
    });
  });
});

// hero parallax tilt
const heroVisual = document.getElementById('heroVisual');
const heroFrame = document.getElementById('heroFrame');
if(heroVisual && window.matchMedia('(min-width:901px)').matches){
  heroVisual.addEventListener('mousemove', (e)=>{
    const r = heroVisual.getBoundingClientRect();
    const x = (e.clientX - r.left)/r.width - .5;
    const y = (e.clientY - r.top)/r.height - .5;
    heroFrame.style.transform = `rotate(1.2deg) rotateY(${x*8}deg) rotateX(${-y*8}deg)`;
  });
  heroVisual.addEventListener('mouseleave', ()=>{ heroFrame.style.transform = 'rotate(1.2deg)'; });
}

// scroll cue
const scrollCue = document.getElementById('scrollCue');
if(scrollCue){ scrollCue.addEventListener('click', ()=>{ document.getElementById('decouvrir').scrollIntoView({behavior:'smooth'}); }); }

// before/after toggle
const baBtns = document.querySelectorAll('.ba-btn');
const baImgs = document.querySelectorAll('.ba-img');
const baTag = document.getElementById('ba-tag');
baBtns.forEach(btn=>{
  btn.addEventListener('click', ()=>{
    const target = btn.dataset.target;
    baBtns.forEach(b=>b.classList.remove('active'));
    btn.classList.add('active');
    baImgs.forEach(img=>{ img.classList.toggle('active', img.dataset.slide===target); });
    if(baTag){
      baTag.textContent = target === 'before' ? 'Avant' : 'Après';
      baTag.className = 'ba-tag ' + (target === 'before' ? 'before-tag' : 'after-tag');
    }
  });
});

// sticky cta after hero
const hero = document.querySelector('.hero');
const stickyCta = document.getElementById('stickyCta');
if(hero && stickyCta){
  const heroObs = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{ stickyCta.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); });
  },{threshold:0});
  heroObs.observe(hero);
}

// mobile nav menu
const navBurger = document.getElementById('navBurger');
const navMobilePanel = document.getElementById('navMobilePanel');
if(navBurger && navMobilePanel){
  navBurger.addEventListener('click', ()=>{
    navBurger.classList.toggle('is-open');
    navMobilePanel.classList.toggle('is-open');
  });
  navMobilePanel.querySelectorAll('a').forEach(a=>{
    a.addEventListener('click', ()=>{
      navBurger.classList.remove('is-open');
      navMobilePanel.classList.remove('is-open');
    });
  });
}

// product page: quantity stepper
document.querySelectorAll('.qty-stepper').forEach(stepper=>{
  const input = stepper.querySelector('input');
  stepper.querySelectorAll('button').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      let val = parseInt(input.value || '1', 10);
      val = btn.dataset.step === 'up' ? val + 1 : Math.max(1, val - 1);
      input.value = val;
    });
  });
});

// product page: gallery thumbnails
document.querySelectorAll('.pdp-thumb').forEach(thumb=>{
  thumb.addEventListener('click', ()=>{
    const stage = thumb.closest('.pdp-gallery')?.querySelector('.product-stage');
    if(!stage) return;
    thumb.parentElement.querySelectorAll('.pdp-thumb').forEach(t=>t.classList.remove('active'));
    thumb.classList.add('active');
    stage.querySelectorAll('.color-img').forEach(img=>{
      img.classList.toggle('active', img.dataset.color === thumb.dataset.color);
    });
  });
});